// Estado Peticion es el estado del registro respecto de logalty
export const CONSTANTE_ESTADO_PENDIENTE_ENVIAR = '01';
export const CONSTANTE_ESTADO_ENVIANDO = '02';
export const CONSTANTE_ESTADO_EN_CURSO = '03';
export const CONSTANTE_ESTADO_FINALIZADO = '04';
export const CONSTANTE_ESTADO_ERROR_EN_ENVIO = '05';
export const CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS = '06';
export const CONSTANTE_ESTADO_PENDIENTE_CERTIFICADO_POSTAL = '07';
export const CONSTANTE_ESTADO_FINALIZADO_VERSION_NUEVA_HOST = '08';
export const CONSTANTE_ESTADO_PENDIENTE_CANCELACION = '09';
export const CONSTANTE_ESTADO_CANCELADO = '10';

//Estado Fichero hace referencia a como esta el registro respecto del FTP al servidor documental:
export const CONSTANTE_ESTADO_DOCUMENTO_GENERADO = '01';
export const CONSTANTE_ESTADO_DOCUMENTO_EN_CURSO = '02';
export const CONSTANTE_ESTADO_DOCUMENTO_FINALIZADO = '03';
export const CONSTANTE_ESTADO_DOCUMENTO_ENVIADO_BSF = '04';
export const CONSTANTE_ESTADO_DOCUMENTO_ENVIADO_FTP = '04';
export const CONSTANTE_ESTADO_DOCUMENTO_SITUADO_PARA_DESCARGA_BSF = '05';
export const CONSTANTE_ESTADO_DOCUMENTO_FINALIZADO_VERSION_NUEVA_HOST = '06';
export const CONSTANTE_ESTADO_DOCUMENTO_ELIMINADO_VERSION_NUEVA_HOST = '07';
export const CONSTANTE_ESTADO_DOCUMENTO_CANCELADO = '08';
export const CONSTANTE_ESTADO_ERROR_LOGALTY_RESPONSE = '09';

//Document_result:
export const CONSTANTE_ESTADO_OK = '7';
export const CONSTANTE_ESTADO_KO = '8';
export const CONSTANTE_ESTADO_PENDIENTE_CERTIFICADOS_DR = '06';
export const CONSTANTE_FORMATO_DE_PETICION_ERRONEO = '99901';
export const CONSTANTE_ERROR_AL_AVISAR_AL_RECEPTOR = '99903';
export const CONSTANTE_ERROR_DE_VALIDACION_DE_PIN = '99904';
export const CONSTANTE_ESTADO_DE_TIEMPO_EXPIRADO = '99906';
export const CONSTANTE_ESTADO_CERRADO_POR_EMISOR = '99932';

//Register_user
export const CHAIN = 'C';
export const CDS = 'S';
export const COMMERCIAL_EXTERNAL = 'O';
export const COMMERCIAL_INTERNAL = 'I';
export const DDGG = 'F';
export const DDGG_WEB = 'W';
export const BUSINESS_DIRECTOR = 'Y';
export const OFFICE_DIRECTOR = 'D';
export const ESTABLISHMENT = 'E';
export const MACRO_CHAIN = 'X';
export const MACRO_OFFICE = 'Z';
export const OFFICE_BS = 'M';
export const PRESCRIBER = 'P';
export const VENDOR = 'V';
export const ADMINISTRATOR = 'A';

//Certified payments
export const CERTIFIED_PAYMENT_TRUE = 'X';
export const LOCALSTORAGE_HASCERTIFIEDPAYMENT = 'hasCertifiedPayment';

//Register User ERRORS
export const ERROR_USER_DUPLICATED = '-7';
